import { render, staticRenderFns } from "./dogStandard.vue?vue&type=template&id=4ad5ed32"
import script from "./dogStandard.vue?vue&type=script&lang=js"
export * from "./dogStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports